/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';

// icon

// import constants
import {PRIMARY_INSURANCE_TYPE_OPTIONS, SECONDARY_INSURANCE_TYPE_OPTIONS, POLICY_HOLDER_RELATIONSHIP_OPTIONS} from '../../constsnts/patientEnrollmentConstants'

// import custom components
import CustomTextField from '../Common/FormMUIWrapperComponents/CustomTextField';
import CustomSingleSelect from '../Common/FormMUIWrapperComponents/CustomSingleSelect';

// import constants
import { TEXT_FIELD_CONST } from '../Common/FormMUIWrapperComponents/CustomTextField/Constants';
import { SELECT_FIELD_CONST } from '../Common/FormMUIWrapperComponents/CustomSingleSelect/Constants'

// Import styles
import styles from './InsuranceForm.styles.module.css';
import CommonStyles from '../Common/CommonStyles.css';

const InsuranceForm = props => {
    const enrolledInsuranceData = useSelector(state => state.idtfPatientEnrollment.patientEnrollment && state.idtfPatientEnrollment.patientEnrollment.enrolledInsuranceData);
    const [formData, setFormData] = useState({
        primaryInsuranceType: enrolledInsuranceData && enrolledInsuranceData.primary_insurance && enrolledInsuranceData.primary_insurance.insuranceType ? PRIMARY_INSURANCE_TYPE_OPTIONS.find((item)=> {if(item.value ==  enrolledInsuranceData.primary_insurance.insuranceType) {return item}}) : {},
        primaryMedicareID: enrolledInsuranceData && enrolledInsuranceData.primary_insurance && enrolledInsuranceData.primary_insurance.medicareId ? enrolledInsuranceData.primary_insurance.medicareId : '',
        primaryInsuranceCompanyName: enrolledInsuranceData && enrolledInsuranceData.primary_insurance && enrolledInsuranceData.primary_insurance.insuranceCompanyName ? enrolledInsuranceData.primary_insurance.insuranceCompanyName : '',
        primaryInsuranceGroup: enrolledInsuranceData && enrolledInsuranceData.primary_insurance && enrolledInsuranceData.primary_insurance.insuranceGroup ? enrolledInsuranceData.primary_insurance.insuranceGroup : '',
        primaryInsuranceAuthorizationNumber: enrolledInsuranceData && enrolledInsuranceData.primary_insurance && enrolledInsuranceData.primary_insurance.insuranceAuthorizationNumber ? enrolledInsuranceData.primary_insurance.insuranceAuthorizationNumber : '',
        primaryInsuranceHolderName: enrolledInsuranceData && enrolledInsuranceData.primary_insurance && enrolledInsuranceData.primary_insurance.policyHolderName ? enrolledInsuranceData.primary_insurance.policyHolderName : '',
        primaryInsuranceHolderRelationship: enrolledInsuranceData && enrolledInsuranceData.primary_insurance && enrolledInsuranceData.primary_insurance.policyHolderRelationship ? POLICY_HOLDER_RELATIONSHIP_OPTIONS.find((item)=> {if(item.value ==  enrolledInsuranceData.primary_insurance.policyHolderRelationship) {return item}}) : {},
        primarySubscriberId: enrolledInsuranceData && enrolledInsuranceData.primary_insurance && enrolledInsuranceData.primary_insurance.subscriberId ? enrolledInsuranceData.primary_insurance.subscriberId : '',
        secondaryInsuranceType: enrolledInsuranceData && enrolledInsuranceData.secondary_insurance && enrolledInsuranceData.secondary_insurance.insuranceType ? SECONDARY_INSURANCE_TYPE_OPTIONS.find((item)=> {if(item.value ==  enrolledInsuranceData.secondary_insurance.insuranceType) {return item}}) : {},
        secondaryMedicareID: enrolledInsuranceData && enrolledInsuranceData.secondary_insurance && enrolledInsuranceData.secondary_insurance.medicareId ? enrolledInsuranceData.secondary_insurance.medicareId : '',
        secondaryInsuranceCompanyName: enrolledInsuranceData && enrolledInsuranceData.secondary_insurance && enrolledInsuranceData.secondary_insurance.insuranceCompanyName ? enrolledInsuranceData.secondary_insurance.insuranceCompanyName : '',
        secondaryInsuranceGroup: enrolledInsuranceData && enrolledInsuranceData.secondary_insurance && enrolledInsuranceData.secondary_insurance.insuranceGroup ? enrolledInsuranceData.secondary_insurance.insuranceGroup : '',
        secondaryInsuranceAuthorizationNumber: enrolledInsuranceData && enrolledInsuranceData.secondary_insurance && enrolledInsuranceData.secondary_insurance.insuranceAuthorizationNumber ? enrolledInsuranceData.secondary_insurance.insuranceAuthorizationNumber : '',
        secondaryInsuranceHolderName: enrolledInsuranceData && enrolledInsuranceData.secondary_insurance && enrolledInsuranceData.secondary_insurance.policyHolderName ? enrolledInsuranceData.secondary_insurance.policyHolderName : '',
        secondaryInsuranceHolderRelationship: enrolledInsuranceData && enrolledInsuranceData.secondary_insurance && enrolledInsuranceData.secondary_insurance.policyHolderRelationship ? POLICY_HOLDER_RELATIONSHIP_OPTIONS.find((item)=> {if(item.value ==  enrolledInsuranceData.secondary_insurance.policyHolderRelationship) {return item}}) : {},
        secondarySubscriberId: enrolledInsuranceData && enrolledInsuranceData.secondary_insurance && enrolledInsuranceData.secondary_insurance.subscriberId ? enrolledInsuranceData.secondary_insurance.subscriberId : '',
    });

    // initial validation is false, so set error as true
    const [formErrorState, setFormErrorState] = useState(true)
    const {
        me,
        validateMainForm,
        formNameSpace,
    } = props

    // update text field data to state
    const handleFormDataUpdate = (e, stateKey, val) => {
        const { value } = e.target;
        if (stateKey) {
            const tempFormData = { ...formData };
            switch (stateKey) {
                // handle state for dd select
                case 'primaryInsuranceType':
                    const selectedPI = PRIMARY_INSURANCE_TYPE_OPTIONS.find(o => o.value === value);
                    if (selectedPI) {
                        tempFormData.primaryInsuranceType = selectedPI;
                    }
                    break;
                case 'primaryInsuranceHolderRelationship':
                    const selectedPHI = POLICY_HOLDER_RELATIONSHIP_OPTIONS.find(o => o.value === value);
                    if (selectedPHI) {
                        tempFormData.primaryInsuranceHolderRelationship = selectedPHI;
                    }
                    break;
                case 'secondaryInsuranceType':
                    const selectedSI = SECONDARY_INSURANCE_TYPE_OPTIONS.find(o => o.value === value);
                    if (selectedSI) {
                        tempFormData.secondaryInsuranceType = selectedSI;
                    }
                    break;
                case 'secondaryInsuranceHolderRelationship':
                    const selectedSIT = POLICY_HOLDER_RELATIONSHIP_OPTIONS.find(o => o.value === value);
                    if (selectedSIT) {
                        tempFormData.secondaryInsuranceHolderRelationship = selectedSIT;
                    }
                    break;
                    break;
                // handle state for Text field
                case 'primaryMedicareID':
                case 'primaryInsuranceCompanyName':
                case 'primaryInsuranceGroup':
                case 'primaryInsuranceAuthorizationNumber':
                case 'primaryInsuranceHolderName':
                case 'primarySubscriberId':
                case 'secondaryMedicareID':
                case 'secondaryInsuranceCompanyName':
                case 'secondaryInsuranceGroup':
                case 'secondaryInsuranceAuthorizationNumber':
                case 'secondaryInsuranceHolderName':
                case 'secondarySubscriberId':
                    tempFormData[stateKey] = value;
                default:
                    break;
            }
            setFormData(tempFormData)
        }
    }

    // validate Form state
    const validateForm = state => {
        // if state true, means error, so update state
        if (state) {
            setFormErrorState(state);
        } else {
            // check if all required field is filled
            if (
                !_.isEmpty(formData.primaryInsuranceType) &&
                !_.isEmpty(formData.secondaryInsuranceType)
            ) {
                setFormErrorState(false);
            }
            // If Self pay is slected
            if (formData.primaryInsuranceType.value == 'self_pay') {
                if (formData.secondaryInsuranceType.value == 'none') {
                    setFormErrorState(false);
                }
            }

            // If none is slected
            if (formData.secondaryInsuranceType.value == 'none') {
                if (formData.primaryInsuranceType.value == 'self_pay') {
                    setFormErrorState(false);
                }
            }
            // If medicare is selected =>
            if (formData.primaryInsuranceType.value == 'medicare') {
                if (formData.primaryMedicareID !== '') {
                    setFormErrorState(false);
                }
            }
            if (formData.secondaryInsuranceType.value == 'medicare') {
                if (formData.secondaryMedicareID !== '') {
                    setFormErrorState(false);
                }
            }

            // If commercial insurance is selected =>
            if (formData.primaryInsuranceType.value == 'commercial_insurance') {
                if (
                    formData.primaryInsuranceCompanyName !== '' &&
                    formData.primaryInsuranceGroup !== '' &&
                    formData.primaryInsuranceHolderName !== '' &&
                    formData.primarySubscriberId !== '' &&
                    !_.isEmpty(formData.primaryInsuranceHolderRelationship)
                ) {
                    setFormErrorState(false);
                }
            }
            if (formData.secondaryInsuranceType.value == 'commercial_insurance') {
                if (
                    formData.secondaryInsuranceCompanyName !== '' &&
                    formData.secondaryInsuranceGroup !== '' &&
                    formData.secondaryInsuranceHolderName !== '' &&
                    formData.secondarySubscriberId !== '' &&
                    !_.isEmpty(formData.secondaryInsuranceHolderRelationship)
                ) {
                    setFormErrorState(false);
                }
            }
        }
    };

    useEffect(() => {
        // if form data is updated, pass the updated data to Parent form with error state
        validateMainForm(formNameSpace, formErrorState, formData);
    }, [formData])

    // on change of errorState of form
    useEffect(() => {
        validateMainForm(formNameSpace, formErrorState, formData);
    }, [formErrorState])

    return (
        <div className={styles.pageContainer}>
            <h1 className={styles.title}>Insurance</h1>
            <Grid container spacing={5}>
                {/* ============= Start of Grid ============= */}
                {/* Basic Details section */}
                <Grid item xs={4}>
                    <CustomSingleSelect
                        label="Insurance Type"
                        placeholder='Select Insurance Type'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        menuItems={PRIMARY_INSURANCE_TYPE_OPTIONS}
                        valueKey='value'
                        labelKeys={['label']}
                        mandatory={true}
                        selectedValue={formData.primaryInsuranceType}
                        stateKey='primaryInsuranceType'
                        // errorText={ADDRESS_PATIENT_PO_ERROR}
                        // validation={validateAddressPOBox}
                        validateForm={validateForm}
                        handleChange={handleFormDataUpdate}
                    />
                </Grid>
                <Grid item xs={8}>
                    {/* Empty space as per figma */}
                </Grid>
                {formData.primaryInsuranceType.value == "medicare" &&
                    <React.Fragment>
                        <Grid item xs={4}>
                            <p className={styles.insuranceMedicareNote}>
                                Check that Enrollment Name matches <br /> the Medicare Card exactly.
                            </p>
                            <CustomTextField
                                label="Medicare ID"
                                mandatory={true}
                                placeholder='Enter Medicare ID'
                                helperText={`Enrollment Name must match Medicare Card exactly`}
                                size={TEXT_FIELD_CONST.SIZE.SMALL}
                                value={formData.primaryMedicareID}
                                stateKey='primaryMedicareID'
                                validateForm={validateForm}
                                onChange={handleFormDataUpdate}
                            />
                        </Grid>
                    </React.Fragment>
                }
                {formData.primaryInsuranceType.value == "commercial_insurance" &&
                    <React.Fragment>
                        <Grid item xs={4}>
                            <CustomTextField
                                label="Insurance Company Name"
                                mandatory={true}
                                placeholder='Enter insurance company name'
                                size={TEXT_FIELD_CONST.SIZE.SMALL}
                                value={formData.primaryInsuranceCompanyName}
                                stateKey='primaryInsuranceCompanyName'
                                validateForm={validateForm}
                                onChange={handleFormDataUpdate}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextField
                                label="Insurance group"
                                mandatory={true}
                                placeholder='Enter insurance Group'
                                size={TEXT_FIELD_CONST.SIZE.SMALL}
                                value={formData.primaryInsuranceGroup}
                                stateKey='primaryInsuranceGroup'
                                validateForm={validateForm}
                                onChange={handleFormDataUpdate}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextField
                                label="Insurance Authorization Number"
                                placeholder='Enter insurance authorization number'
                                size={TEXT_FIELD_CONST.SIZE.SMALL}
                                value={formData.primaryInsuranceAuthorizationNumber}
                                stateKey='primaryInsuranceAuthorizationNumber'
                                onChange={handleFormDataUpdate}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextField
                                label="Policy Holder Name"
                                mandatory={true}
                                placeholder='Enter insurance policy holder name'
                                size={TEXT_FIELD_CONST.SIZE.SMALL}
                                value={formData.primaryInsuranceHolderName}
                                stateKey='primaryInsuranceHolderName'
                                validateForm={validateForm}
                                onChange={handleFormDataUpdate}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomSingleSelect
                                label="Policy Holder Relationship"
                                placeholder='Select Relationship'
                                variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                                menuItems={POLICY_HOLDER_RELATIONSHIP_OPTIONS}
                                valueKey='value'
                                labelKeys={['label']}
                                mandatory={true}
                                selectedValue={formData.primaryInsuranceHolderRelationship}
                                stateKey='primaryInsuranceHolderRelationship'
                                validateForm={validateForm}
                                handleChange={handleFormDataUpdate}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextField
                                label="Subscriber/Policy/Member ID"
                                mandatory={true}
                                placeholder='Enter subscriber/policy/member ID'
                                size={TEXT_FIELD_CONST.SIZE.SMALL}
                                value={formData.primarySubscriberId}
                                stateKey='primarySubscriberId'
                                validateForm={validateForm}
                                onChange={handleFormDataUpdate}
                            />
                        </Grid>
                    </React.Fragment>
                }
                {/* ============= End of Grid ============= */}
            </Grid>
            <h1 className={styles.title}>Secondary Insurance</h1>
            <Grid container spacing={5}>
                {/* ============= Start of Grid ============= */}
                {/* Basic Details section */}
                <Grid item xs={4}>
                    <CustomSingleSelect
                        label="Insurance Type"
                        placeholder='Select Insurance Type'
                        variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                        menuItems={SECONDARY_INSURANCE_TYPE_OPTIONS}
                        valueKey='value'
                        labelKeys={['label']}
                        mandatory={true}
                        selectedValue={formData.secondaryInsuranceType}
                        stateKey='secondaryInsuranceType'
                        validateForm={validateForm}
                        handleChange={handleFormDataUpdate}
                    />
                </Grid>
                <Grid item xs={8}>
                    {/* Empty space as per figma */}
                </Grid>
                {formData.secondaryInsuranceType.value == "medicare" &&
                    <React.Fragment>
                        <Grid item xs={4}>
                            <p className={styles.insuranceMedicareNote}>
                                Check that Enrollment Name matches <br /> the Medicare Card exactly.
                            </p>
                            <CustomTextField
                                label="Medicare ID"
                                mandatory={true}
                                placeholder='Enter Medicare ID'
                                helperText={`Enrollment Name must match Medicare Card exactly`}
                                size={TEXT_FIELD_CONST.SIZE.SMALL}
                                value={formData.secondaryMedicareID}
                                stateKey='secondaryMedicareID'
                                validateForm={validateForm}
                                onChange={handleFormDataUpdate}
                            />
                        </Grid>
                    </React.Fragment>
                }
                {formData.secondaryInsuranceType.value == "commercial_insurance" &&
                    <React.Fragment>
                        <Grid item xs={4}>
                            <CustomTextField
                                label="Insurance Company Name"
                                mandatory={true}
                                placeholder='Enter insurance company name'
                                size={TEXT_FIELD_CONST.SIZE.SMALL}
                                value={formData.secondaryInsuranceCompanyName}
                                stateKey='secondaryInsuranceCompanyName'
                                validateForm={validateForm}
                                onChange={handleFormDataUpdate}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextField
                                label="Insurance group"
                                mandatory={true}
                                placeholder='Enter insurance Group'
                                size={TEXT_FIELD_CONST.SIZE.SMALL}
                                value={formData.secondaryInsuranceGroup}
                                stateKey='secondaryInsuranceGroup'
                                validateForm={validateForm}
                                onChange={handleFormDataUpdate}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextField
                                label="Insurance Authorization Number"
                                placeholder='Enter insurance authorization number'
                                size={TEXT_FIELD_CONST.SIZE.SMALL}
                                value={formData.secondaryInsuranceAuthorizationNumber}
                                stateKey='secondaryInsuranceAuthorizationNumber'
                                onChange={handleFormDataUpdate}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextField
                                label="Policy Holder Name *"
                                mandatory={true}
                                placeholder='Enter insurance policy holder name'
                                size={TEXT_FIELD_CONST.SIZE.SMALL}
                                value={formData.secondaryInsuranceHolderName}
                                stateKey='secondaryInsuranceHolderName'
                                validateForm={validateForm}
                                onChange={handleFormDataUpdate}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomSingleSelect
                                label="Insurance Type"
                                placeholder='Select Insurance Type'
                                variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
                                menuItems={POLICY_HOLDER_RELATIONSHIP_OPTIONS}
                                valueKey='value'
                                labelKeys={['label']}
                                mandatory={true}
                                selectedValue={formData.secondaryInsuranceHolderRelationship}
                                stateKey='secondaryInsuranceHolderRelationship'
                                validateForm={validateForm}
                                handleChange={handleFormDataUpdate}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <CustomTextField
                                label="Subscriber/Policy/Member ID"
                                mandatory={true}
                                placeholder='Enter subscriber/policy/member ID'
                                size={TEXT_FIELD_CONST.SIZE.SMALL}
                                value={formData.secondarySubscriberId}
                                stateKey='secondarySubscriberId'
                                validateForm={validateForm}
                                onChange={handleFormDataUpdate}
                            />
                        </Grid>
                    </React.Fragment>
                }
                {/* ============= End of Grid ============= */}
            </Grid>
        </div>
    );
};

export default InsuranceForm;



// WEBPACK FOOTER //
// ./src/views/components/InsuranceForm/InsuranceForm.jsx